import React from 'react';
import SEO from '../components/SEO';
import Footer from '../components/Footer';
import AnimatedSection from '../components/AnimatedSection';

export default function AboutUs() {
  return (
    <div className="min-h-screen bg-white pt-16 flex flex-col">
      <SEO 
        title="About GearLoop | Your Local Outdoor Gear Rental Marketplace"
        description="Learn about GearLoop's mission to make outdoor adventures accessible and sustainable through local gear sharing. Join our community of outdoor enthusiasts."
        keywords={[
          'about gearloop',
          'outdoor gear marketplace',
          'sustainable outdoor equipment',
          'gear sharing platform',
          'outdoor community',
          'local adventure gear',
          'eco-friendly outdoor rental',
          'outdoor equipment sharing'
        ]}
        type="article"
      />
      
      <main className="flex-grow">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
          <AnimatedSection>
            <h1 className="text-4xl font-bold text-center mb-12">About GearLoop</h1>
          </AnimatedSection>
          
          <div className="prose lg:prose-lg mx-auto">
            <AnimatedSection delay={0.2}>
              <p className="text-lg mb-6">
                Founded in 2025, GearLoop emerged from a simple idea: make outdoor adventures more accessible 
                and sustainable. Our founders, avid outdoor enthusiasts, noticed how much gear sat unused in 
                garages and storage units while others struggled to afford quality equipment for their adventures.
              </p>
            </AnimatedSection>

            <AnimatedSection delay={0.3}>
              <h2 className="text-2xl font-semibold mt-12 mb-6">Our Mission</h2>
              <p className="text-lg mb-6">
                We're on a mission to create the world's largest community of outdoor enthusiasts sharing 
                high-quality gear. By connecting people who have gear with those who need it, we're making 
                outdoor activities more accessible while reducing waste and environmental impact.
              </p>
            </AnimatedSection>

            <AnimatedSection delay={0.4}>
              <h2 className="text-2xl font-semibold mt-12 mb-6">Our Community</h2>
              <p className="text-lg mb-6">
                GearLoop is more than just a rental platform - it's a community of passionate outdoor 
                enthusiasts. From experienced mountaineers to weekend warriors, our members share not just 
                their gear, but their knowledge and love for the outdoors.
              </p>
            </AnimatedSection>

            <AnimatedSection delay={0.5}>
              <h2 className="text-2xl font-semibold mt-12 mb-6">Join Us</h2>
              <p className="text-lg mb-6">
                Whether you're looking to make some extra income from your unused gear or seeking affordable 
                equipment for your next adventure, GearLoop is here to help. Join our community today and 
                be part of the sharing economy revolution in outdoor recreation.
              </p>
            </AnimatedSection>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
}